<template>
  <div class="common-page money-management">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="流水号:" prop="fnNo">
                <el-input clearable placeholder="请输入" v-model="searchForm.fnNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5" v-if="companyType === '1'">
              <el-form-item label="分公司:">
                <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                  <el-option
                    v-for="item in belongCompanyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="交易对象:" prop="targetName">
                <el-input clearable placeholder="请输入" v-model="searchForm.targetName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="交易渠道:" prop="tradeChannel">
                <el-select style="width: 100%" v-model="searchForm.tradeChannel" clearable placeholder="请选择">
                  <el-option
                    v-for="item in tradeChannelData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="交易完成时间:">
                <custom-date-range
                  :start-date="searchForm.startTime"
                  :end-date="searchForm.endTime"
                  @update:startDate="(val) => (searchForm.startTime = val)"
                  @update:endDate="(val) => (searchForm.endTime = val)"></custom-date-range>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="收支类型:" prop="fnType">
                <el-select style="width: 100%" v-model="searchForm.fnType" clearable placeholder="请选择">
                  <el-option
                    v-for="item in fnTypeData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="交易类型:" prop="tradeType">
                <el-select style="width: 100%" v-model="searchForm.tradeType" clearable placeholder="请选择">
                  <el-option
                    v-for="item in tradeTypeData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
                <el-button type="primary" @click="handleDownload('资金流水.xlsx')" :loading="downloadLoading">
                  导出
                </el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <div class="search-table-box">
        <div class="list-box">
          <div class="list-box-num">￥{{ numberToThousand(overviewData.incomingAmount) }}</div>
          <div class="list-box-label">收入金额</div>
        </div>
        <div class="list-box">
          <div class="list-box-num">￥{{ numberToThousand(overviewData.outgoingAmount) }}</div>
          <div class="list-box-label">支出金额</div>
        </div>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @selectionChange="handleSelectionChange"
        @pagination="handleSizeChange">
        <template v-slot:tradeChannel="{ row }">
          <el-tag v-if="row.tradeChannel === 1">线下</el-tag>
          <el-tag type="warning" v-if="row.tradeChannel === 2">微信</el-tag>
        </template>
        <template v-slot:targetName="{ row }">
          <span class="color1966ff cursor" @click="turnTo(row)">{{row.targetName}}</span>
        </template>
        <template v-slot:tradeType="{ row }">
          <span v-if="row.tradeType === 10">订单支付</span>
          <span v-if="row.tradeType === 11">订单退款</span>
          <span v-if="row.tradeType === 20">钱包充值</span>
          <span v-if="row.tradeType === 30">代理商结算单</span>
          <span v-if="row.tradeType === 31">服务商结算单</span>
        </template>
        <template v-slot:fnType="{ row }">
          <span v-if="row.fnType === 1">收入</span>
          <span v-if="row.fnType === 2">支出</span>
        </template>
      </custom-table>
    </div>
    <agentBillDetail ref="agentBillDetailRef"></agentBillDetail>
    <supplierBillDetail ref="supplierBillDetailRef"></supplierBillDetail>
    <orderDetail ref="orderDetailRef"></orderDetail>
    <rechargeDetail ref="rechargeDetailRef"></rechargeDetail>
  </div>
</template>

<script>
import agentBillDetail from "@/views/FinancialManagement/AgentSettlementBill/statementAccount/detail.vue"
import supplierBillDetail from "@/views/FinancialManagement/SupplierSettlementBill/statementAccount/detail.vue"
import rechargeDetail from "@/views/FinancialManagement/RechargeRecord/detail.vue"
import orderDetail from "@/views/OrderManagement/detail.vue";
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import tableMixin from "@/mixin/tableMixin";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import {numberToThousand} from "@/utils/tool"
import { downloadTable, getPage, overviewMethod } from "./api";
export default {
  name: "FundTransaction",
  mixins: [tableMixin],
  components: {
    CustomTabBox,
    OperateBox,
    rechargeDetail,
    CustomTable,
    orderDetail,
    agentBillDetail,
    supplierBillDetail,
    CustomDateRange,
  },
  data() {
    return {
      getTableMethod: getPage,
      downloadFileMethod: downloadTable,
      searchForm: {
        "belongCompanyId": "",
        "endTime": "",
        "fnNo": "",
        "fnType": "",
        "startTime": "",
        "targetName": "",
        "tradeChannel": "",
        "tradeType": ""
      },
      isImmediatelyGetData: true,
      haveBelongCompany: true,
      tableColumn: [
        {
          label: "流水号",
          prop: "fnNo",
          align: "left",
          show: true,
        },
        {
          label: "交易对象",
          prop: "targetName",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "交易渠道",
          prop: "tradeChannel",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "收支类型",
          prop: "fnType",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "交易类型",
          prop: "tradeType",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "交易金额",
          prop: "amount",
          align: "left",
          show: true,
        },
        {
          label: "交易时间",
          prop: "fnTime",
          align: "left",
          show: true,
        },
        {
          label: "备注",
          prop: "remark",
          align: "left",
          show: true,
        },
      ],
      agentData: [],
      tradeTypeData: [
        {
          label: '订单支付',
          value: 10,
        },
        {
          label: '订单退款',
          value: 11,
        },
        {
          label: '钱包充值',
          value: 20,
        },
        {
          label: '代理商结算单',
          value: 30,
        },
        {
          label: '服务商结算单',
          value: 31,
        }
      ],
      tradeChannelData: [
        {
          label: '线下',
          value: 1,
        },
        {
          label: '微信',
          value: 2,
        }
      ],
      fnTypeData: [
        {
          label: '收入',
          value: 1,
        },
        {
          label: '支出',
          value: 2,
        }
      ],
      overviewData: {},
      selectRows: []
    };
  },
  created() {
    this.getOverview()
  },
  mounted() {
  },
  methods: {
    numberToThousand,
    getOverview() {
      overviewMethod({
        "endTime": this.searchForm.endTime,
        "fnNo": this.searchForm.fnNo,
        "fnType": this.searchForm.fnType,
        "startTime": this.searchForm.startTime,
        "targetName": this.searchForm.targetName,
        "tradeChannel": this.searchForm.tradeChannel,
        "tradeType": this.searchForm.tradeType,
      }).then(response => {
        if (response.code === 200) {
          this.overviewData = response.data
        }
      })
    },
    handleSet() {
      if (this.selectRows.length === 0) {
        this.$message.warning("请选择订单")
        return
      } else {
        this.setOrder(this.selectRows)
      }
    },
    handleSelectionChange(rows) {
      this.selectRows = [...rows]
    },
    turnTo(row) {
      if (row.tradeType === 10 || row.tradeType === 11) {
        this.$refs.orderDetailRef.init({ orderId: row.targetId })
      } else if (row.tradeType === 20) {
        this.$refs.rechargeDetailRef.init({ rechargeId: row.targetId })
      } else if (row.tradeType === 30) {
        this.$refs.agentBillDetailRef.init({ billId: row.targetId })
      } else if (row.tradeType === 31) {
        this.$refs.supplierBillDetailRef.init({ billId: row.targetId })
      }
    },
    setOrder(row) {
      this.$confirm(`确定生成结算单？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        reconciliationOrder({
          orderIds: row.map(item => item.orderId),
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("结算单已生成")
            this.tableOptions.pageNumber = 1;
            this.getTableData();
          }
        });
      });
    },
    handleDetail(row) {
      this.$refs.detail.init(row);
    },
  },
};
</script>
<style lang="scss" scoped>
.money-management {
  ::v-deep .el-input__inner{
    height: auto;
  }
  .top-box {
    .tab-box {
      padding: 0.2rem 0 0 0.2rem;
    }
  }

  .search-table-box {
    display: flex;
    margin: 0.16rem -0.1rem 0;

    .list-box {
      width: 33.33%;
      height: 0.9rem;
      border-radius: 0.08rem;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0.1rem;

      .list-box-num {
        font-size: 0.24rem;
        color: #000000;
        padding-bottom: 0.1rem;
        font-weight: bold;
      }

      .list-box-label {
        font-size: 0.14rem;
        color: #434343;
      }
    }
  }

  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .custom-table-box {
    padding-top: 0;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
